import React from "react";
import { deepCopy } from "../../utils";

function DualEventListSelect({ events, selectedEvents, enableSyslogProcessing, onChange, disabled }) {

    const disabledSyslog = !enableSyslogProcessing;

    const onEventClick = (event) => {
        if (!disabledSyslog) {
            const eventsCopy = deepCopy(selectedEvents);
            eventsCopy.push(event);
            onChange(eventsCopy);
        }
    }

    const onSelectedEventClick = (event) => {
        const eventsCopy = deepCopy(selectedEvents);
        const toRemove = eventsCopy.find(el => el.id === event.id);
        eventsCopy.splice(eventsCopy.indexOf(toRemove), 1);
        onChange(eventsCopy);
    }

    const selectAllEvents = () => {
        onChange(events);
    }

    const unselectAllEvents = () => {
        onChange([]);
    }

    return (
        <div className={`modal-v2-step3-duallist ${disabledSyslog ? "is-disabled" : ""}`}>
            <div className="modal-v2-step3-list-card">
                <div className="modal-v2-step3-list-header">
                    <div className="modal-v2-step3-list-title">Events</div>
                </div>

                <div className="modal-v2-step3-list-body">
                    <ul className="modal-v2-step3-list">
                        {
                            events
                                .filter(event => !selectedEvents.find(el => el.id === event.id))
                                .map((event, index) => (
                                    <li
                                        key={event.id || index}
                                        className="modal-v2-step3-list-item"
                                        onClick={disabled ? null : () => onEventClick(event)}
                                    >
                                        <span className="modal-v2-step3-list-item-box" />
                                        <span>{event.name}</span>
                                    </li>
                                ))
                        }
                    </ul>
                </div>
            </div>

            <div className="modal-v2-step3-controls">
                <button
                    type="button"
                    className="modal-v2-step3-control-btn"
                    onClick={disabled ? null : () => unselectAllEvents()}
                    aria-label="Remove all selected events"
                >
                    &lt;&lt;
                </button>

                <button
                    type="button"
                    className="modal-v2-step3-control-btn"
                    onClick={disabled ? null : () => selectAllEvents()}
                    aria-label="Select all available events"
                >
                    &gt;&gt;
                </button>
            </div>

            <div className="modal-v2-step3-list-card">
                <div className="modal-v2-step3-list-header">
                    <div className="modal-v2-step3-list-title">Selected Events</div>
                </div>

                <div className="modal-v2-step3-list-body">
                    <ul className="modal-v2-step3-list">
                        {
                            selectedEvents.map((event, index) => (
                                <li
                                    key={event.id || index}
                                    className="modal-v2-step3-list-item is-selected"
                                    onClick={disabled ? null : () => onSelectedEventClick(event)}
                                >
                                    <span className="modal-v2-step3-list-item-box is-selected" />
                                    <span>{event.name}</span>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default DualEventListSelect;
